import { makeStyles, mergeClasses } from '@fluentui/react-components';

import { palette, tokens } from '../theme';
import { isBugWorkItem, isRequestWorkItem } from './workItemColors';

export type WorkItemTypeBadgeProps = {
    workItemType: string;
    title?: string | null;
};

// The work item's type as a pill. Shared by both pickers so the plan rows and
// the day dialog's rows read identically.
export const WorkItemTypeBadge: React.FC<WorkItemTypeBadgeProps> = ({ workItemType, title }) => {
    const classes = useStyles();
    const tone = isBugWorkItem(workItemType, title)
        ? classes.bug
        : isRequestWorkItem(workItemType, title)
          ? classes.request
          : classes.issue;

    return <span className={mergeClasses(classes.badge, tone)}>{workItemType}</span>;
};

const useStyles = makeStyles({
    badge: {
        fontSize: '10px',
        fontWeight: tokens.fontWeightSemibold,
        padding: '1px 5px',
        borderRadius: '999px',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        flexShrink: 0,
    },
    bug: {
        color: palette.bugBadgeText,
        backgroundColor: palette.bugBadgeBg,
    },
    issue: {
        color: palette.issueBadgeText,
        backgroundColor: palette.issueBadgeBg,
    },
    request: {
        color: palette.requestBadgeText,
        backgroundColor: palette.requestBadgeBg,
    },
});
